/**
 * Banner API slice (promotional banner impressions/clicks/dismissal).
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const bannerApi = {
  getAvailable: async (platform) => {
    const params = platform ? `?platform=${platform}` : '';
    const data = await fetchWithAuth(`/json/banners/available${params}`, {
      method: 'GET',
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to fetch banners', data.status || 400, data);
    }

    return data.data?.banners || [];
  },

  markSeen: async (bannerId, variant = null) => {
    const data = await fetchWithAuth(`/json/banners/${bannerId}/seen`, {
      method: 'POST',
      body: { variant },
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to record impression', data.status || 400, data);
    }

    return data.data || {};
  },

  markClicked: async (bannerId, variant = null) => {
    const data = await fetchWithAuth(`/json/banners/${bannerId}/click`, {
      method: 'POST',
      body: { variant },
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to record click', data.status || 400, data);
    }

    return data.data || {};
  },

  dismiss: async (bannerId) => {
    const data = await fetchWithAuth(`/json/banners/${bannerId}/dismiss`, {
      method: 'POST',
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to dismiss banner', data.status || 400, data);
    }

    return data.data || {};
  },

};
